import { render } from "./GestionCreditos.vue?vue&type=template&id=866bdc1a&scoped=true"
import script from "./GestionCreditos.vue?vue&type=script&lang=js"
export * from "./GestionCreditos.vue?vue&type=script&lang=js"

import "./GestionCreditos.vue?vue&type=style&index=0&id=866bdc1a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-866bdc1a"]])

export default __exports__